import {logIn} from "../AuthModal";
import {logErrorToSentry} from "../../../../../utils/errors/logErrorToSentry";

import type {AppState} from "@stores/AppState";


import {PAGES, type ViewStoreModel} from "@stores/ViewStore";


export const autoLogin = async (appState: AppState, viewStore: ViewStoreModel, username: string, password: string, updateNameFields?: any) => {
    try {
        return await logIn(appState, viewStore, username, password, updateNameFields);
    } catch (error: any) {
        logErrorToSentry(error);
        viewStore.openPageByName(PAGES.SIGN_IN, undefined, undefined, {
            emailDefaultValue: username
        });
        return false;
    }
}
